import {Component, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {ToastsContainer} from "./core/notifications/toasts-container.component";
import {environment} from "../environments/environment";
import {AmplifyAuthenticatorModule} from "@aws-amplify/ui-angular";
import { I18n } from 'aws-amplify/utils';
import {Amplify} from "aws-amplify";
import { translations } from '@aws-amplify/ui-angular';
import awsExports from '../aws-exports.js';

//https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/en.ts
translations["de"]["Enter your Nickname"] = "Geben Sie Ihren Nickname ein"
I18n.putVocabularies(translations);
I18n.setLanguage('de');

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgbModule, ToastsContainer, AmplifyAuthenticatorModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Spotfight Tippspiel';

  constructor() {
    Amplify.configure(awsExports);
    console.log(environment.production)
    console.log(environment.version)
  }
}
